<!-- ================管理端-听评课详情====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">听评课详情</div>
        </div>
        <div class="create-content-container">
            <div class="event-base-info-container">
                <div class="event-part1-l">
                    <div class="event-info-item-auto">
                        <span class="item-span">课程标题：</span>
                        {{ form.title || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">所属机构：</span>
                        {{ orgName || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">学段·年级·学科：</span>
                        {{ form.periodName || '--' }}•{{ form.gradeName || '--' }}•{{ form.subjectName || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">听评课性质：</span>
                        <span v-if="form.lessonNature == 1 || form.lessonNature == null || form.lessonNature == ''">普通</span>
                        <span v-if="form.lessonNature == 2">名师工作室</span>
                        <span v-if="form.lessonNature == 3">名校长工作室</span>
                        <span v-if="form.lessonNature == 4">群组任务</span>
                    </div>
                    <div class="event-info-item-auto" v-if="form.groupName">
                        <span class="item-span">工作室/群组：</span>
                        {{ form.groupName }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">类型：</span>
                        <span v-if="form.type === 0">推门</span>
                        <span v-if="form.type === 1">线上</span>
                        <span v-if="form.type === 2">录播视频</span>
                    </div>
                    <div class="event-info-item-auto" v-if="form.address">
                        <span class="item-span">听课地址：</span>
                        {{ form.address }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">任务时段：</span>
                        {{ timestampToTime(form.beginTime) }} 至 {{ timestampToTime(form.endTime) }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">评课截止时间：</span>
                        {{ timestampToTime(form.rateEndTime) }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">授课教师：</span>
                        {{ form.lectureTeacherName || '--' }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.leadTeacherName">
                        <span class="item-span">评课组长：</span>
                        {{ form.leadTeacherName }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.guideExpertTxt">
                        <span class="item-span">指导专家：</span>
                        {{ form.guideExpertTxt }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.listenTeacherTxt">
                        <span class="item-span">听课教师：</span>
                        {{ form.listenTeacherTxt }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.rateTeacherTxt">
                        <span class="item-span">评课教师：</span>
                        {{ form.rateTeacherTxt }}
                    </div>
                    <div class="event-info-item-auto" v-if="form.scaleList && form.scaleList.length > 0">
                        <span class="item-span">听评量表：</span>
                        <div style="display: inline-block;">
                            <div v-for="item in form.scaleList" :key="item.scaleId" style="color: #377f7f; cursor: pointer; display: inline-block; margin-right: 10px;" @click="preview(item)">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>

                    <div class="info-column-container mt15" v-if="form.fileList && form.fileList.length > 0">
                        <div class="column-title">附件资料</div>
                    </div>
                    <div class="b-file-list" v-if="form.fileList && form.fileList.length > 0">
                        <div class="b-file-item" v-for="item in form.fileList" :key="item.fileId">
                            <div class="b-file-title" @click="downloadFile(item)">{{ item.fileName }}</div>
                            <div class="b-file-view" title="预览">
                                <el-image @click="handleFileStatus(item.status)" class="b-file-icon" style="margin-top: 5px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl, item.pages)">
                                </el-image>
                            </div>
                            <div class="b-file-download" title="下载" @click="downloadFile(item)">
                                <img class="b-file-icon" style="margin-top: 3px" :src="require('@/assets/file/file_download.png')" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="info-column-container mt15" v-if="form.type === 0">
                        <div class="column-title">地图位置</div>
                    </div>
                    <el-form-item label="" v-show="form.type === 0">
                        <aMap isDetail v-if="isShow" ref="zdyMap" @getGeocoder="getGeocoder" :oldCenter="oldCenter"
                              :isShowAMap="true">
                        </aMap>
                    </el-form-item>
                </div>
                <div class="event-part1-r">
                    <div class="event-info-item-auto">
                        <span class="item-span">听评课封面：</span>
                    </div>
                    <div class="event-base-info-cover">
                        <img class="img-100" :src="form.coverUrl" alt="">
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title="previewData.title ? previewData.title : '预览'" v-model="previewShow" width="60%">
            <div class="mb30" v-for="(item, index) in previewData.questionList" :key="index">
                <div class="mb15" v-if="item.type != 3">
                    <h3 style="margin: 0 0;"><span style="padding-right: 10px;">{{ index + 1 }}.</span>{{ item.questionName }}
                        <span style="padding-left: 10px;color: #999;font-weight: normal;font-size: 14px;">[{{
                            item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容' : ''
                        }}]</span>
                        <span v-if="item.type == 4 && item.totalScore" style="color: #efa030;font-weight: normal;font-size: 14px;">(分值：{{ item.totalScore }})</span>
                    </h3>
                </div>
                <div v-if="item.type == 1">
                    <el-radio-group disabled class="ml-4">
                        <el-radio label="1" size="small" v-for="(items, indexs) in item.itemList" :key="indexs">
                            <span style="color: #333;">{{ items.itemName }}</span><span style="color: #efa030;">(分值：{{ items.itemValue }})</span>
                        </el-radio>
                    </el-radio-group>
                </div>
                <div v-if="item.type == 2">
                    <el-checkbox-group disabled class="ml-4">
                        <el-checkbox size="small" v-for="(items, indexs) in item.itemList" :key="indexs">
                            <span style="color: #333;">{{ items.itemName }}</span><span style="color: #efa030;">(分值：{{ items.itemValue }})</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-if="item.type == 4" style="width: 100%;">
                    <el-input style="width: 100%;" disabled :rows="2" type="textarea" placeholder="" />
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import aMap from '@/components/aMap/index'
import { timestampToTime } from "@/utils/date";
import { queryDict } from "@/api/admin/dict";
import { queryUserManagerOrg } from "@/api/admin/org";
import { evaluationInfo, rateScaleInfo } from "@/api/admin/evaluation";
import { downloadFile } from "@/utils/download";

export default {
    name: "evaLessonDetail",
    components: { aMap },
    data() {
        return {
            timestampToTime,
            downloadFile,
            lessonId: '',
            isShow: false,
            oldCenter: [],
            form: {
                countyId: '',
                schoolId: '',
                type: 0,
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                title: '',
                lectureTeacherName: '',
                leadTeacherName: '',
                guideExpertTxt: '',
                listenTeacherTxt: '',
                rateTeacherTxt: '',
                scaleList: [],
                fileList: [],
                coverUrl: '',
                address: '',
            },
            orgList: [],
            periodList: [],
            previewData: {},
            previewShow: false,
        }
    },
    computed: {
        orgName() {
            const org = this.orgList.find(e => e.orgId == this.form.countyId || e.orgId == this.form.schoolId)
            return org ? org.orgName : ''
        }
    },
    created() {
        this.queryUserManagerOrg();
        this.getQueryDict();
    },
    mounted() {
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId;
            this.getlessonInfo();
        } else {
            this.isShow = true;
        }
    },
    methods: {
        queryUserManagerOrg() {
            queryUserManagerOrg().then(res => {
                if (res.data && res.data.code === 1) {
                    this.orgList = res.data.data || [];
                }
            })
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.periodList = res.data.data;
                }
            })
        },
        getlessonInfo() {
            evaluationInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.form = res.data.data;
                    this.form.fileList = this.form.fileList || [];
                    var rateTeacherTxt = [];
                    (this.form.rateTeacherList || []).forEach(e => {
                        rateTeacherTxt.push(e.trueName)
                    })
                    this.form.rateTeacherTxt = rateTeacherTxt.join('、')

                    var listenTeacherTxt = []
                    ;(this.form.listenTeacherList || []).forEach(e => {
                        listenTeacherTxt.push(e.trueName)
                    })
                    this.form.listenTeacherTxt = listenTeacherTxt.join('、')

                    var guideExpertTxt = []
                    ;(this.form.guideExpertList || []).forEach(e => {
                        guideExpertTxt.push(e.trueName)
                    })
                    this.form.guideExpertTxt = guideExpertTxt.join('、')

                    if (this.form.type === 0) {
                        this.oldCenter = [this.form.lng, this.form.lat]
                    }
                    this.isShow = true;
                    if (this.form.type === 0) {
                        setTimeout(() => {
                            if (this.$refs.zdyMap) {
                                this.$refs.zdyMap.center = this.oldCenter;
                                this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                            }
                        }, 100)
                    }
                }
            })
        },
        preview(item) {
            rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.previewData = res.data.data;
                    this.previewShow = true;
                }
            })
        },
        getGeocoder(e) {
            console.log(e);
        },
        handleFileStatus(status) {
            if (status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
        backList() {
            this.$router.push({ path: "/evaLesson" });
        },
    }
}
</script>

<style scoped>
.info-column-container {
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #377f7f;
}

.column-title {
    height: 20px;
    line-height: 20px;
    color: #ff9a4c;
    font-weight: bold;
    border-left: 4px solid #377f7f;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}

.mt10 {
    margin-top: 10px;
}

.mt15 {
    margin-top: 15px;
}

.event-base-info-container {
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}

.event-part1-l {
    width: calc(100% - 300px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}

.event-info-item-auto {
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
    color: #333;
}

.event-part1-r {
    width: 300px;
    height: 100%;
}

.event-base-info-cover {
    width: 270px;
    height: 152px;
    box-sizing: border-box;
    margin-top: 10px;
}

.event-base-info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.item-span {
    font-weight: bold;
    color: #377f7f;
    white-space: nowrap;
}

.b-file-list {
    width: 100%;
    padding: 10px 0;
}

.b-file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 28px;
    padding: 4px 0;
    box-sizing: border-box;
}

.b-file-title {
    flex: 1;
    font-size: 14px;
    color: #333;
    line-height: 20px;
    cursor: pointer;
    word-break: break-all;
    padding-right: 10px;
}

.b-file-title:hover {
    color: #377f7f;
    font-weight: bold;
}

.b-file-view,
.b-file-download {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.b-file-view {
    margin-right: 10px;
}

.b-file-icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.img-100 {
    width: 100%;
    height: 100%;
}

@media (max-width: 1024px) {
    .event-base-info-container { flex-direction: column; }
    .event-part1-l { width: 100%; padding-right: 0; }
    .event-part1-r { width: 100%; margin-top: 20px; }
    .event-base-info-cover { width: 240px; height: 135px; }
    .b-file-list { width: 100%; }
}
</style>
